import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getSpecificFeature } from "../../../redux/features/Settings/Management/Features";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs";
import CommonDetailCard from "../../../components/_utils/CommonDetailCard";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";

import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider.js";
import Loader from "../../../components/Loader/Index.jsx";

const FeaturesDetail = () => {
  const { user_feature_id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showFeatureDetails, setShowFeatureDetails] = useState(true);
  const [showServiceDetails, setShowServiceDetails] = useState(true);
  const [isAtTop, setIsAtTop] = useState(true);
  const scrollRef = useRef(null);

  const [activeButton, setActiveButton] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [tabIndex, setTabIndex] = useState(
    activeButton === GlobalConfiguration?.lengthCheckOne
      ? GlobalConfiguration?.lengthCheckOne
      : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");

  const { getSpecificFeatureData, getSpecificFeatureIsLoading } = useSelector(
    (state) => state.featuresSlice,
  );

  useLayoutEffect(() => {
    if (tabIndex !== prevIndex) {
      const direction =
        tabIndex > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setTimeout(() => {
        setPrevIndex(tabIndex);
      }, IntervalConfiguration?.intervalSemiMid);
    }
  }, [tabIndex]);

  useEffect(() => {
    dispatch(getSpecificFeature({ id: user_feature_id }));
  }, [dispatch, user_feature_id]);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;

      const scrollTop = scrollRef.current.scrollTop;
      setIsAtTop(scrollTop === 0);
    };

    const container = scrollRef.current;
    container?.addEventListener("scroll", handleScroll);

    return () => {
      container?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {}, [dispatch]);

  const featureDetails = getSpecificFeatureData?.features?.[0];
  const servicesDetails =
    getSpecificFeatureData?.features?.[0]?.user_features_line_items || [];

  const togglefeatureDetails = () => {
    setShowFeatureDetails(true);
    setShowServiceDetails(false);
    setActiveButton(GlobalConfiguration?.lengthCheckZero);
  };

  const toggleServiceDetails = () => {
    setShowFeatureDetails(false);
    setShowServiceDetails(true);
    setActiveButton(GlobalConfiguration?.lengthCheckOne);
  };

  return (
    <div className="flex flex-col ptc-main-bg-div top-top-base left-left-base w-full-width h-screen bg-primary-bg z-z-index-base">
      <div
        className={`ptc-navbar-padding-div w-full fixed Qsmd:relative top-top-base z-z-index-header
    Qmd:h-[calc(var(--navbar-breadcrumb-height))] 
    h-auto block
    ${isAtTop ? "bg-transparent Qsmd:bg-primary-nav" : "bg-transparent"}
  `}
      >
        <div className="block Qsmd:hidden fixed w-width-full z-z-index-fixed-ui shadow-box-shadow-bottom">
          <TopNavComponent
            topNavHeader={"Features"}
            topNavSubText="Detail page"
            isFormattingNotRequired={true}
          />
        </div>
      </div>

      {getSpecificFeatureIsLoading ? (
        <div className="flex items-center justify-center h-full w-full">
          <Loader />
        </div>
      ) : (
        <div
          ref={scrollRef}
          className="flex flex-col h-full overflow-y-auto overflow-x-hidden"
        >
          <div className="h-auto bg-primary-card Qsmd:bg-primary-nav block pt-padding-xl mt-margin-md Qsmd:pt-padding-base Qsmd:mt-margin-base">
            <div
              className={`w-full max-w-tab-width-normal m-auto bg-primary-nav`}
            >
              <div className=" flex flex-row Qsmd:border-b-border Qsmd:border-primary-bg  justify-between">
                <div className="w-width-full flex flex-col Qsmd:flex-row Qsmd:py-padding-md px-padding-base Qsmd:px-padding-md Qlg:px-padding-base">
                  <div className="w-full Qsmd:flex">
                    <div className="accountName Qsmd:mx-margin-base Qmd:pl-padding-sm Qsmd:pl-padding-sm Qsmd:py-padding-base py-mobile-padding-l mx-mobile-margin-l Qsmd:px-padding-base border-b-border border-primary-bg Qsmd:border-none w-auto flex flex-col Qsmd:w-width-md gap-y-gap-xs whitespace-normal break-words justify-center">
                      <TitleSubtitlePair
                        title={featureDetails?.feature_name}
                        subtitle="Feature name"
                      />
                    </div>
                    {/* <div className="h-[var(--border)] bg-primary-bg Qsmd:hidden block mx-margin-button-l"></div> */}
                    <div className="border-r border-solid border-primary-bg Qsmd:mx-margin-base mx-margin-button-l"></div>
                    <div className="accountStatus Qsmd:py-padding-base py-padding-button-l flex flex-col w-auto Qsmd:w-width-md gap-y-gap-xs mx-mobile-margin-l Qsmd:m-margin-base Qsmd:px-padding-md border-b-border border-primary-bg Qsmd:border-none justify-center">
                      <TitleSubtitlePair
                        title={featureDetails?.feature_header}
                        subtitle="Feature header"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="h-[var(--border)] bg-primary-bg block Qsmd:hidden Qsmd:mx-margin-base mx-margin-button-l"></div> */}
              <div className="primaryDetailsBlock2 flex flex-row justify-between">
                <div className="w-width-full flex flex-col Qsmd:flex-row Qsmd:py-padding-md px-padding-base Qsmd:px-padding-md Qlg:px-padding-base">
                  <div className="w-full Qsmd:flex">
                    {" "}
                    <div className="Qsmd:border-none Qsmd:mx-margin-base Qsmd:pl-padding-sm Qsmd:w-width-md Qsmd:py-padding-base py-padding-button-l Qmd:pl-padding-sm flex flex-col Qsmd:px-padding-base mx-mobile-margin-l w-auto gap-y-gap-xs justify-center border-b-border border-primary-bg">
                      <TitleSubtitlePair
                        titleColor={
                          featureDetails?.is_delete === "N"
                            ? "settled"
                            : "failed"
                        }
                        title={
                          featureDetails?.is_delete === "N"
                            ? "Active"
                            : "Inactive"
                        }
                        subtitle="Status"
                      />
                    </div>
                    {/* <div className="h-[var(--border)] bg-primary-bg Qsmd:hidden block mx-margin-button-l"></div> */}
                    <div className="border-r border-solid border-primary-bg"></div>
                    <div className="accountHolderName Qsmd:py-padding-base p-mobile-padding-l flex flex-col w-width-full Qsmd:w-width-md gap-y-gap-xs Qsmd:px-padding-md whitespace-normal break-words justify-center">
                      <TitleSubtitlePair
                        subtitle="Feature privilege"
                        title={featureDetails?.privilege || "N/A"}
                        titleColor="text-primary"
                        variant="md"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full">
            <div className="m-auto max-w-tab-width-normal relative z-z-index-base">
              <div className="flex pt-padding-md pl-mobile-padding-l Qsmd:pl-padding-md Qlg:pl-padding-base">
                <div className="flex gap-gap-sm bg-primary-card rounded-border-radius-md w-auto Qsm:overflow-x-hidden">
                  <SwitcherTabs
                    tabs={[
                      {
                        label: "Details",
                        key: "details",
                        handler: togglefeatureDetails,
                      },
                      {
                        label: "Services",
                        key: "services",
                        handler: toggleServiceDetails,
                      },
                    ]}
                    initialActiveTab={
                      showFeatureDetails ? "details" : "services"
                    }
                    setIndex={setTabIndex}
                  />
                </div>
              </div>
            </div>
            {showFeatureDetails ? (
              <div className={animationClass}>
                <div className="flex flex-col Qsmd:flex-row my-margin-md px-mobile-padding-l Qsmd:px-padding-md lg:px-padding-base gap-gap-md Qlg:justify-center">
                  <CommonDetailCard
                    cardTitle="Feature Description"
                    numCols={1}
                    variant="third"
                    entries={[
                      {
                        heading: "Description",
                        content: featureDetails?.feature_description || "—",
                        type: "text",
                      },
                    ]}
                  />

                  <CommonDetailCard
                    cardTitle="Origin Details"
                    numCols={1}
                    variant="third"
                    entries={[
                      {
                        heading: "Created On",
                        content: formatDateViewAll(
                          featureDetails?.created_on,
                          true,
                          true,
                        ),
                        type: "text",
                      },
                    ]}
                  />

                  <CommonDetailCard
                    cardTitle="Support Information"
                    numCols={1}
                    variant="third"
                    entries={[
                      {
                        heading: "Feature ID",
                        content: featureDetails?.feature_id || "—",
                        type: "text",
                      },
                    ]}
                  />
                </div>
              </div>
            ) : showServiceDetails ? (
              <div className={animationClass}>
                <div className="flex flex-row flex-wrap my-margin-md px-mobile-padding-l Qsmd:px-padding-md Qlg:px-padding-base gap-gap-md mx-auto max-w-tab-width-normal">
                  {servicesDetails.length >
                  GlobalConfiguration?.lengthCheckZero ? (
                    servicesDetails.map((service, index) => (
                      <CardContainer
                        key={service.id}
                        context={service}
                        isNoHoverRequired={false}
                        isDisabled={false}
                        isSelected={false}
                        onClickHandler={() => {
                          navigate(
                            `/settings/service_view_all/service_detail_page/${service?.platform_service_id}`,
                          );
                        }}
                      >
                        <card-body>
                          <TextWithIcon
                            type={"text"}
                            fontWeight={"normal"}
                            text={service?.service_name}
                            subText={"Service name"}
                            textColor={"var(--text-primary)"}
                          />
                          <TextWithIcon
                            type={"text"}
                            fontWeight={"normal"}
                            text={service?.service_desc}
                            subText={"Service description"}
                            textColor={"var(--text-primary)"}
                          />
                        </card-body>
                      </CardContainer>
                    ))
                  ) : (
                    <div className="text-text-secondary text-font-md">
                      No services assigned
                    </div>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default FeaturesDetail;
